var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-bar',{on:{"changeEmpresa":_vm.changeEmpresa}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"lebot-welcome text-center"},[_c('div',[(!_vm.session)?_c('loading'):_vm._e(),_c('p',{staticClass:"mt-4"},[_vm._v("Por favor aguarde, o Bot está sendo iniciado")])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }